export default function AnimatedArrow({ color = "white" }) {
  return (
    <div class="w-4 h-4 relative overflow-hidden">
      <div className="absolute w-4 transform transition-transform duration-400 translate-x-0 translate-y-0 group-hover:translate-x-full group-hover:-translate-y-full">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          fill="currentColor"
          viewBox="0 0 16 16"
        >
          <g>
            <path
              id="FIRST"
              stroke={color}
              stroke-width="1.5"
              d="M4 4h8m0 0v8m0-8-9 9"
            ></path>
          </g>
        </svg>
      </div>
      <div className="absolute w-4 transform transition-transform duration-400 -translate-x-full translate-y-full group-hover:translate-x-0 group-hover:translate-y-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          fill="currentColor"
          viewBox="0 0 16 16"
        >
          <g>
            <path
              id="FIRST"
              stroke={color}
              stroke-width="1.5"
              d="M4 4h8m0 0v8m0-8-9 9"
            ></path>
          </g>
        </svg>
      </div>
    </div>
  );
}
